<template>
    <!--理财产品详情-->
    <el-dialog
      title="产品详情"
      :visible.sync="prdDetailVisible"
      width="1000px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body>
      <div class="detailDiv">
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">产品代码</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.prdCode | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">产品名称</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.prdName | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">产品状态</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.saleStatus | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">存单期限</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.termLimit | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">年利率</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.annualInsrate | emptyCheckFilter}}%</el-col>
          <el-col :span="6" class="detailTitle">计息方式</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.interestType | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">付息方式</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.payIntType | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">递增金额(元)</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.incrementalAmount | moneyFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">单笔最高限额(元)</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.perBuyMaxMoney | moneyFilter}}</el-col>
          <el-col :span="6" class="detailTitle">单人最高限额(元)</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.onePerBuyMaxMoney | moneyFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">发售总额(元)</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.saleAmt | moneyFilter}}</el-col>
          <el-col :span="6" class="detailTitle">是否提前支取</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.isAdvWithdraw | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">可售余额(元)</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.remainAmounts | moneyFilter}}</el-col>
          <el-col :span="6" class="detailTitle">币种</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.currencyType | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">可提前支取次数</el-col>
          <el-col :span="6" class="detailKey">{{depositDetail.advWithdrawNumber | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">&nbsp;</el-col>
          <el-col :span="6" class="detailKey">&nbsp;</el-col>
        </el-row>
      </div>
      <el-row style="text-align:right">
        <el-button @click="prdDetailVisible = false" type="primary">关闭</el-button>
      </el-row>
    </el-dialog>
</template>
<script>
export default {
  name: 'depositDetailDialog',
  data() {
    return {
      prdDetailVisible: false,
      depositDetail: {},
    };
  },
  filters: {
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // console.log(f)
      // 如果为空则返回默认值
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        // 补0
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。         👇是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 将分割的入参，重新拼起来  100,000.00
      return parts.join('.');
    },
  },
  methods: {
    // 理财产品详情查询
    getDepositDetail(prdId) {
      this.prdDetailVisible = true;
      if (prdId === '') {
        console.log('产品编码为空');
        return;
      }
      const params = {
        data: {
          prdId,
          prdType: '2',
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.getDepositDetail, params).then((res) => {
        this.depositDetail = res.data.productInfo;
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .detailRow {
    border: 1px solid #EBEEF5;
    border-bottom: 0px;
  }
  .detailRow:last-child {
    border-bottom: 1px solid #EBEEF5;
  }
  .detailDiv {
    position: relative;
    top: -20px;
  }
  .detailTitle {
    background-color: #F5F7FA;
    padding: 15px 15px 15px 0;
    text-align: right;
  }
  .detailKey {
    padding: 15px 0px 15px 15px;
  }
</style>
